/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:7488492f-5306-4da5-8660-559e329f75ce",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_mGayDvyue",
    "aws_user_pools_web_client_id": "4fe4o9nnp42miocvui6054hri2",
    "oauth": {
        "domain": "minesight-beta.auth.us-east-2.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "http://localhost:9000,http://localhost:9000/login,https://beta.minesight.nutrien.com/login",
        "redirectSignOut": "http://localhost:9000,http://localhost:9000/login,https://beta.minesight.nutrien.com/login",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "minesightborer489fc8a0deb24b949d89a80e93dc9b6284926-beta",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
